import { Link, useParams } from 'react-router';
import { cn } from '@/lib/utils';
import type { ServiceDTO } from '@/features/services/api';
import type { ShiftWithTotals } from '@/features/shifts/schemas';

interface ShiftTabsProps {
  activeShifts: ShiftWithTotals[];
  services: ServiceDTO[];
}

export function ShiftTabs({ activeShifts, services }: ShiftTabsProps) {
  const { shiftId } = useParams();
  if (activeShifts.length <= 1) return null;
  const svcMap = new Map(services.map((s) => [s.id, s]));
  return (
    <div
      role="tablist"
      aria-label="Plantões ativos"
      className="flex gap-1 overflow-x-auto border-b border-(--color-border) bg-(--color-surface) px-2 py-1"
    >
      {activeShifts.map((s) => {
        const svc = svcMap.get(s.shift.serviceId);
        const active = s.shift.id === shiftId;
        return (
          <Link
            key={s.shift.id}
            to={`/shift/${s.shift.id}`}
            role="tab"
            aria-selected={active}
            className={cn(
              'flex shrink-0 items-center gap-2 rounded-md px-3 py-1.5 text-sm transition-colors',
              active
                ? 'bg-(--color-surface-elevated) font-medium text-(--color-fg)'
                : 'text-(--color-fg-muted) hover:bg-(--color-surface-elevated)',
            )}
          >
            <span
              className="h-3 w-3 rounded-sm"
              style={{ backgroundColor: svc?.color ?? '#888' }}
              aria-hidden="true"
            />
            {svc?.name ?? 'Plantão'}
          </Link>
        );
      })}
    </div>
  );
}
